import { navigations } from '../../navigations'

export const SET_USER_NAVIGATION = 'SET_USER_NAVIGATION'

export const getfilteredNavigations = (navList = [], role) => {
	return navList.reduce((array, nav) => {
		if (nav.auth) {
			if (nav.auth.includes(role)) {
				array.push(nav)
			}
		} else {
			if (nav.children) {
				nav.children = getfilteredNavigations(nav.children, role)
				array.push(nav)
			} else {
				array.push(nav)
			}
		}
		return array
	}, [])
}

export function getNavigationByUser(signinUser = {}) {
	return (dispatch) => {
		let filteredNavigations = getfilteredNavigations(navigations, signinUser.role)

		dispatch({
			type: SET_USER_NAVIGATION,
			payload: [...filteredNavigations]
		})
	}
}
